export default __webpack_public_path__ + "static/media/sponsor-fluminense.51b3a64d.png";